import { jsx as _jsx } from "react/jsx-runtime";
import { colors, typography } from '@mehilainen/design-system-tokens';
// NOTE: Do not import these from lib root! Will cause circular deps
import { Times } from '../../icons';
import { focusVisible } from './shared';
export const getThemeChip = (tokens) => ({
    MuiChip: {
        defaultProps: {
            deleteIcon: _jsx(Times, {}),
        },
        styleOverrides: {
            root: ({ ownerState }) => {
                const isFilled = ownerState.variant === 'filled';
                // TODO: It would be more nice if we had mapping to used color object from tokens BUT error does not contain 700 variant
                if (ownerState.color === 'error') {
                    return Object.assign(Object.assign({ color: isFilled ? colors.White : colors.Error600, backgroundColor: isFilled ? colors.Error600 : colors.Error100 }, (!isFilled && {
                        borderColor: colors.Error500,
                        borderWidth: '1px',
                        borderStyle: 'solid',
                    })), { '&[class*="MuiChip-clickable"]': {
                            '&:hover': isFilled
                                ? { backgroundColor: colors.Error600 }
                                : {
                                    backgroundColor: colors.Error100,
                                    borderColor: colors.Error600,
                                },
                        }, '&[class*="Mui-focusVisible"]': Object.assign(Object.assign({}, focusVisible), { backgroundColor: isFilled ? colors.Error600 : colors.Error100, outlineOffset: '2px' }) });
                }
                if (ownerState.disabled) {
                    return Object.assign(Object.assign({ opacity: '1 !important', color: isFilled ? colors.White : colors.Gray500, backgroundColor: isFilled ? colors.Gray500 : colors.White }, (!isFilled && {
                        borderColor: colors.Gray500,
                        borderWidth: '1px',
                        borderStyle: 'solid',
                    })), { '&[class*="Mui-focusVisible"]': Object.assign(Object.assign({}, focusVisible), { backgroundColor: isFilled ? colors.Gray500 : colors.White, outlineOffset: '2px' }) });
                }
                return Object.assign(Object.assign({ color: isFilled ? colors.White : colors.Primary700, backgroundColor: isFilled ? colors.Primary500 : colors.Primary100 }, (!isFilled && {
                    borderColor: colors.Primary500,
                    borderWidth: '1px',
                    borderStyle: 'solid',
                })), { '&[class*="MuiChip-clickable"]': {
                        '&:hover': isFilled
                            ? { backgroundColor: colors.Primary600 }
                            : {
                                backgroundColor: colors.Primary100,
                                borderColor: colors.Primary600,
                            },
                    }, '& > [class*="MuiSvgIcon-root"]': {
                        color: 'inherit',
                        fontSize: 'inherit',
                        '&:hover': {
                            color: 'inherit',
                        },
                    }, 
                    // NOTE: MUI specifically tells in the console to do this like this instead of using focusVisible property in styleOverrides
                    '&[class*="Mui-focusVisible"]': Object.assign(Object.assign({}, focusVisible), { backgroundColor: isFilled ? colors.Primary500 : colors.Primary100, outlineOffset: '2px' }) });
            },
            sizeSmall: {
                fontSize: tokens.uiElementChips.sizeSmall.fontSize,
                fontWeight: typography.baseTypography.weight.Medium,
                lineHeight: typography.baseTypography.height.Small,
                paddingLeft: tokens.uiElementChips.sizeSmall.padding,
                paddingRight: tokens.uiElementChips.sizeSmall.padding,
                gap: '6px',
            },
            sizeMedium: {
                fontSize: tokens.uiElementChips.sizeMedium.fontSize,
                fontWeight: typography.baseTypography.weight.Medium,
                lineHeight: typography.baseTypography.height.Small,
                paddingLeft: tokens.uiElementChips.sizeMedium.padding,
                paddingRight: tokens.uiElementChips.sizeMedium.padding,
                gap: '6px',
            },
            icon: {
                width: '16px',
                height: '16px',
                margin: 0,
            },
            deleteIcon: {
                margin: 0,
                width: '16px',
                height: '16px',
            },
            label: {
                display: 'flex',
                padding: 0,
            },
        },
    },
});
